import React from "react";
import PropTypes from "prop-types";
import {
  Input,
  Button,
  Form,
  Space,
  Select,
  DatePicker,
  Col,
  Row,
  Card,
  TreeSelect,
} from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;
const { TreeNode } = TreeSelect;
const FormSearch = ({
  isLoadingExportExcel,
  treeSelectProps,
  formSearch,
  handleSearch,
  handleRefresh,
  handleNewEmployee,
  listRole,
  handleImportExcel,
  handleExportExcel,
  handleDeleteSelectRows,
  selectedRowKeys,
  loadingDeleteRows,
  userStatus,
}) => {
  const { treeData, treeDataDepartmentValue } = treeSelectProps;
  const { t } = useTranslation();

  return (
    <>
      <Card>
        <Form
          form={formSearch}
          layout="vertical"
          autoComplete="off"
          className="pl-1"
        >
          <Row gutter={10}>
            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item
                name="username"
                label={t("userName") + ":"}
                rules={[
                  {
                    message: t("validateUser"),
                    type: "string",
                    min: 1,
                  },
                ]}
              >
                <Input placeholder={t("placeHolderUser")} allowClear={true} />
              </Form.Item>
            </Col>
            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item
                name="fullName"
                label={t("fullName") + ":"}
                rules={[
                  {
                    message: t("validateFullName"),
                    type: "string",
                    min: 1,
                  },
                ]}
              >
                <Input
                  placeholder={t("placeHolderFullName")}
                  allowClear={true}
                />
              </Form.Item>
            </Col>

            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item name="phoneNumber" label={t("phone") + ":"}>
                <Input placeholder={t("plantHolderPhone")} allowClear={true} />
              </Form.Item>
            </Col>

            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item name="email" label={t("email") + ":"}>
                <Input placeholder={t("plantHolderEmail")} allowClear={true} />
              </Form.Item>
            </Col>

            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item
                name="department"
                label={t("companyDepartmentAndGroup") + ":"}
              >
                <TreeSelect
                  showSearch
                  treeNodeFilterProp="title"
                  style={{ width: "100%" }}
                  value={treeDataDepartmentValue}
                  placeholder={t("placeHolderSelectCompanyDepartmentAndGroup")}
                  allowClear
                  onChange={() => handleSearch()}
                >
                  {treeData &&
                    treeData?.map((data) => {
                      return (
                        <TreeNode
                          key={data.key}
                          value={data.value}
                          title={data.title}
                        >
                          {data.children.length > 0
                            ? data.children.map((child) => {
                                return (
                                  <TreeNode
                                    key={child.key}
                                    value={child.value}
                                    title={child.title}
                                  >
                                    {child.children.length > 0
                                      ? child.children.map((childOfChild) => {
                                          return (
                                            <TreeNode
                                              key={childOfChild.key}
                                              value={childOfChild.value}
                                              title={childOfChild.title}
                                            />
                                          );
                                        })
                                      : null}
                                  </TreeNode>
                                );
                              })
                            : null}
                        </TreeNode>
                      );
                    })}
                </TreeSelect>
              </Form.Item>
            </Col>

            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item name="roleName" label={t("role") + ":"}>
                <Select
                  placeholder={t("placeHolderSelectRole")}
                  allowClear
                  showSearch
                  mode="multiple"
                  onChange={() => handleSearch()}
                >
                  {listRole.length > 0 &&
                    listRole.map((item) => {
                      return (
                        <Option key={item._id} value={item._id}>
                          {item.roleName}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>

            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item name="createdTime" label={t("createdTime") + ":"}>
                <DatePicker
                  format={"DD/MM/YYYY"}
                  placeholder={t("createdTime")}
                />
              </Form.Item>
            </Col>

            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item name="status" label={t("activeStatus")}>
                <Select
                  placeholder={t("activeStatus")}
                  allowClear
                  showSearch
                  mode="multiple"
                  onChange={() => handleSearch()}
                >
                  {userStatus.length > 0 &&
                    userStatus.map((item) => {
                      return (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>

            <Col lg={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item className="form-button">
                <Space>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => handleSearch()}
                  >
                    {t("search")}
                  </Button>

                  <Button type="primary" onClick={handleNewEmployee}>
                    {t("create")}
                  </Button>

                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => handleRefresh()}
                  >
                    {t("reload")}
                  </Button>

                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => handleImportExcel()}
                  >
                    {t("excelImport")}
                  </Button>
                  {isLoadingExportExcel ? (
                    <Button
                      style={{ display: "flex" }}
                      type="primary"
                      htmlType="button"
                      loading
                    >
                      {t("waiting")}
                    </Button>
                  ) : null}
                  {!isLoadingExportExcel ? (
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => handleExportExcel()}
                    >
                      {t("excelExport")}
                    </Button>
                  ) : null}

                  <Button
                    disabled={selectedRowKeys.length == 0}
                    loading={loadingDeleteRows}
                    type="danger"
                    htmlType="button"
                    onClick={() => handleDeleteSelectRows()}
                  >
                    {t("delete")}
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};
FormSearch.propTypes = {
  formSearch: PropTypes.any,
  handleSearch: PropTypes.func,
  handleRefresh: PropTypes.func,
  handleNewEmployee: PropTypes.func,
  listRole: PropTypes.any,
  userStatus: PropTypes.array,
  listDepartment: PropTypes.any,
  handleImportExcel: PropTypes.func,
  handleExportExcel: PropTypes.func,
  handleDeleteSelectRows: PropTypes.func,
  selectedRowKeys: PropTypes.any,
  loadingDeleteRows: PropTypes.any,
};
export default FormSearch;
